import { render, staticRenderFns } from "./FbGenericTemplateSetting.vue?vue&type=template&id=99c8e570&"
import script from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js&"
export * from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99c8e570')) {
      api.createRecord('99c8e570', component.options)
    } else {
      api.reload('99c8e570', component.options)
    }
    module.hot.accept("./FbGenericTemplateSetting.vue?vue&type=template&id=99c8e570&", function () {
      api.rerender('99c8e570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/SettingPages/FbGenericTemplateSetting.vue"
export default component.exports